module.exports = __webpack_public_path__ + "media/icons/calendar-0f292610.png";